import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { useCockpitApi } from '@/api/provider';

const DEFAULT_STALE = 30_000;

export function useFeedback() {
  const api = useCockpitApi();
  return useQuery({
    queryKey: ['cockpit', 'feedback'],
    queryFn: () => api.feedback(),
    staleTime: DEFAULT_STALE,
  });
}

export function useDeleteFeedback() {
  const api = useCockpitApi();
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (id: string) => api.deleteFeedback(id),
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: ['cockpit', 'feedback'] });
    },
  });
}

export function useDeleteAllFeedback() {
  const api = useCockpitApi();
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: () => api.deleteAllFeedback(),
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: ['cockpit', 'feedback'] });
    },
  });
}
